<template>
  <div id="table-wrap" ref="booksTable">
    <el-table
      ref="multipleTable"
      class="booksTable-content"
      :data="tableData"
      width="100%"
      :height="tableHeight"
      :header-cell-style="tableHeaderColor"
      @filter-change="filtersHandle"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        align="center"
        v-if="isSelectOverall"
        :key="Math.random()"
        width="50"
      >
      </el-table-column>
      <el-table-column
        v-for="{ prop, label, width, btn } in tableProps"
        :prop="prop"
        :key="prop"
        :label="label"
        align="center"
        :columnKey="prop"
        show-overflow-tooltip
        :fixed="prop === 'handle' ? 'right' : false"
        :filters="isFilters(prop)"
        :width="width"
        v-if="prop != isHandle"
      >
        <template slot-scope="scope">
          <div v-if="prop === 'cover'">
            <img class="booksTable-cover" :src="scope.row.cover" alt="" />
          </div>
          <div v-else-if="prop === 'status'">
            <span v-if="scope.row.status === 0">{{
              $t("content.books.soldOut")
            }}</span>
            <span v-else-if="scope.row.status === 1">{{
              $t("content.books.soldOn")
            }}</span>
          </div>

          <div
            class="omitText"
            v-else-if="
              prop === 'updatedAt' ||
              prop === 'createdAt' ||
              prop === 'created_at' ||
              prop === 'updated_at' ||
              prop === 'end_date'
            "
          >
            <span>{{ scope.row[prop] | filterDate }}</span>
          </div>

          <div v-else-if="prop === 'handle'">
            <span
              :class="btnStyle(item)"
              v-for="item in btn"
              :key="item"
              plain
              @click="tableHandle(item, scope)"
              >{{ item }}</span
            >
          </div>
          <span v-else class="omitText">{{
            scope.row[prop] !== null ? scope.row[prop] : "-"
          }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import ResizeMixin from "@/mixins/resize";
export default {
  mixins: [ResizeMixin],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tableProps: {
      type: Array,
    },
    isSelectOverall: {
      type: Boolean,
      default: false,
    },
    selectDatas: {
      type: Array,
    },
    isHandle: {
      type: String,
    },
  },
  data() {
    return {
      selectDataIds: [],
      resetHeight: null,
      scopeItem: null,
    };
  },
  methods: {
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f7f7f7;font-weight: 500;";
      }
    },
    btnStyle(item) {
      let className;
      switch (item) {
        case this.$t("commonMsg.check"):
        case this.$t("commonMsg.edit"):
          className = "checkDetailsBtn";
          break;
        case this.$t("commonMsg.del"):
          className = "delBtn";
          break;

        default:
          break;
      }
      return className;
    },
    emitEvn(type, scope, evn) {
      let obj = {
        type: type,
        data: scope,
      };
      this.$emit(evn, obj);
    },

    filtersHandle(obj) {
      let key = Object.keys(obj);
      this.$emit("filterEvn", { obj, key: key[0] });
    },

    handleSelectionChange(val) {
      this.selectDataIds = val.map((item) => {
        return item.source_type !== 4 ? item.id : item.ebook_id;
      });

      this.$emit("selectEvnTable", this.selectDataIds);
    },
    toggleSelection() {
      this.selectDataIds.forEach((row) => {
        this.selectDataIds.forEach((row) => {
          this.$refs.multipleTable.clearSelection();
        });
      });
    },
    tableHandle(type, scope) {
      if (type === this.$t("commonMsg.check")) {
        this.emitEvn(type, scope, "tableHandle");
      } else {
        this.emitEvn(type, scope, "ediTableHandle");
      }
    },
    isFilters(prop) {
      switch (prop) {
        case "rate":
          return [
            { text: this.$t("content.books.one"), value: 1 },
            { text: this.$t("content.books.two"), value: 2 },
            { text: this.$t("content.books.three"), value: 3 },
            { text: this.$t("content.books.four"), value: 4 },
            { text: this.$t("content.books.five"), value: 5 },
          ];
        case "status":
          return [
            { text: this.$t("content.books.soldOn"), value: 1 },
            { text: this.$t("content.books.soldOut"), value: 0 },
          ];
        default:
          return null;
      }
    },
  },
  watch: {
    tableData(arr) {
      if (arr.length) {
        this.resizeHandle();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#table-wrap {
  height: 100%;
  .booksTable-cover {
    width: 40px;
    height: auto;
  }
}
</style>
